if($('.type-detail').length){
    var customLine = '<div class="left">'
        customLine += '<div class="logo">'
            customLine += '<img src="'+$('.header-top .site-name img').attr('src')+'" alt="Bertoo">'
        customLine += '</div>'
    customLine += '</div>'
    customLine += '<div class="center">'
        customLine += '<ul>'
            customLine += '<li data-section="description">Popis</li>'
            customLine += '<li data-section="parametrs">Parametry produktu</li>'
            customLine += '<li data-section="shippingPossible">Možnosti dopravy</li>'
        customLine +='</ul>'
    customLine += '</div>'
    customLine += '<div class="right">'
        customLine += '<div class="image"><img src="'+$('.p-image a img').attr('src').replace('/big/', '/related/')+'" alt="Bertoo"></div>'
        customLine += '<div class="nameAndPrice">'
            customLine += '<span class="name">'+$('.p-detail-inner>.p-detail-inner-header>h1').html()+'</span>'
            customLine += '<div class="price">'+$('.p-final-price-wrapper').html()+'</div>'
        customLine += '</div>'
        if($('.tab-content #variants').length){
            customLine += '<div class="addtoCartWrap"><a href="#variants" id="choose-variant" class="btn btn-primary" data-toggle="tab" data-external="1" data-force-scroll="1">Zvolte variantu</a></div>'
        }
        else{
            customLine += '<div class="addtoCartWrap"><span class="addToCart add-to-cart-button btn btn-conversion" data-code="'+$('#product-detail-form input[name="priceId"]').attr('value')+'">Přidat do košíku</span></div>'
        }
    customLine += '</div>'

    if($('body').hasClass('desktop')){
        var customStyle="display:none;"
    }
    else{
        var customStyle = ''
    }
    $('footer#footer').after('<div class="detailFixedCart" style="'+customStyle+'"><div class="container">'+customLine+'</div></div>');
    if($('body.mobile').length){
        $('#tab-content>#description').removeClass('active in')
    }
}


$('html').on('click', '.detailFixedCart .addToCart', function(){
    shoptet.cartShared.addToCart({priceId: $(this).data('code')});
})